import React from "react";
import { Chip } from "@mui/material";
import { alpha, SxProps, Theme } from "@mui/material/styles";
import { VerifiedUser } from "@mui/icons-material";
import { translationService } from "../../services/translation/TranslationService";

/**
 * How an Inspection Graph looks when it is drawn from reviewed data rather than machine output.
 *
 * The two views have the same layout -- pipe, arrows, table -- so without a colour change a
 * reviewer flipping between Inspection Data and the Review Workbench cannot tell at a glance
 * which one they are looking at, or which one they are about to export. Green is the reviewed
 * side throughout (Approve all, the Approved status); the machine view keeps the default blue.
 */

/** Pipe fill on the reviewed view; the machine view keeps PipeDiagram's default blue. */
export const REVIEWED_PIPE_COLOR = "#66bb6a";

/** Frame around the whole graph: a green border on a faint green wash. */
export const reviewedFrameSx: SxProps<Theme> = {
  border: 2,
  borderColor: "success.main",
  borderRadius: 2,
  p: 1.5,
  bgcolor: (t) => alpha(t.palette.success.main, 0.04),
};

/** The table inside it: green header row and border, so the grid matches the pipe. */
export const reviewedGridSx: SxProps<Theme> = {
  borderColor: "success.light",
  "& .MuiTableHead-root .MuiTableCell-root": {
    bgcolor: (t: Theme) => alpha(t.palette.success.main, 0.12),
    color: "success.dark",
  },
};

/** Badge beside the graph's title naming the source. */
export const ReviewedChip: React.FC = () => (
  <Chip
    size="small"
    color="success"
    icon={<VerifiedUser />}
    label={translationService.translate("comparison.detection-source.approved")}
  />
);
